import styled from "styled-components";

export const Wrapper = styled.div`
    
    .top-container {
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #a2a2a2;

        .page-title {
            font-weight: 600;
            font-size: ${props => props.isSmall ? "32px" : "40px"};
            font-family: sans-serif;
            letter-spacing: 2px;
            color: #131f28;
        }

        .month-selector {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 15px;
            font-weight: 600;

            .text {
                font-size: ${props => props.isSmall ? "16px" : "18px"};
            }
            
        }
    }
    .content-container {
        margin: 40px 0;
        
        .loader-div {
            display: flex;
            flex: 1;
            flex-direction: row;
            justify-content: center;
            align-items: center;
        }

        .payrol-container {
            display: flex;
            flex: 1;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
            gap: 20px;

            .expansion-panel {

                .expansion-panel-header {
                    display: flex;
                    flex-direction: row;
                    flex: 1;
                    justify-content: space-between;
                    align-items: center;
                    background: #898e94;
                    color: white;
                    padding: 10px;
                    border-radius: 5px;
                    min-height: 50px;

                    .text-title {
                        font-weight: 600;
                        font-size: ${props => props.isSmall ? "14px" : "16px"};
                    }
                    .text-title-end {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        gap: ${props => props.isSmall ? "5px" : "10px"};

                        .week-dates {
                            font-weight: 600;
                            font-size: ${props => props.isSmall ? "14px" : "16px"};
                        }
                        .expansion-icon {

                        }
                    }
                }
                .expansion-panel-body {
                    margin-top: 20px;

                    .avaiable-payees {
                        display: flex;
                        flex: 1;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        gap: ${props => props.isSmall ? "10px" : "20px"};

                        .avaiable-payeeList {
                            display: flex;
                            flex: 1;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-items: center;
                            gap: ${props => props.isSmall ? "20px" : "40px"};
                            white-space: nowrap;
                            overflow-x: auto;

                            .avaiable-payeeList-box {
                                font-size: ${props => props.isSmall ? "14px" : "16px"};
                                background: #898e94;
                                color: white;
                                width: 100%;
                                padding: 10px;
                                border-radius: 5px;
                                text-align: center;
                                cursor: pointer;
                            }
                        }
                    }

                    .payee-payrol-container {
                        margin-top: 20px;

                        .payee-payrol-details-box {
                            display: flex;
                            flex-direction: row;
                            flex: 1;
                            justify-content: space-between;
                            align-items: center;
                            background: #131f28;
                            padding: 5px 10px;
                            border-radius: 5px;
                            min-height: 50px;
                            
                            .payee-name {
                                font-size: ${props => props.isSmall ? "13px" : "15px"};
                                color: white;
                            }
                            .payee-dues {
                                font-size: ${props => props.isSmall ? "13px" : "15px"};
                                color: white;
                            }
                            .pay-button {
                                .pay-btn {
                                    border: none;
                                    background: #3378b5;
                                    border-radius: 3px;
                                    width: ${props => props.isSmall ? "50px" : "100px"};
                                    font-size: ${props => props.isSmall ? "14px" : "16px"};
                                    height: 35px;
                                    font-weight: 600;
                                    color: white;
                                }
                            }
                        }
                    }
                    .payee-payrol-pay-container {
                        margin-top: 20px;
                    }
                }
            }
        }
    }
    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #131f28;
        border-color: #131f28;  
    }
`;


export const calenderStyles = {
    container: {
        width: 250
    },
    main: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    month: {
        fontSize: 16,
        fontWeight: 600,
        userSelect: 'none'
    },
    disabled: {
        color: '#ccc',
        pointerEvents: 'none',
        cursor: 'not-allowed'
    },
    disabledBtn: {
        color: '#000',
        background: '#cccccc',
        pointerEvents: 'none',
        cursor: 'not-allowed'
    },
    selected: {
        background: '#131f28'
    },
    notSelected: {
        background: '#898e94'
    }
}
